import React from "react";
import { IconType } from "./types";

const Phone: IconType = (props) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      style={{ fillRule: "evenodd", clipRule: "evenodd", fill: "#231F20" }}
      d="M46.7,113.37h34.6c5.54,0,9.98-4.41,9.98-9.92V24.55c0-5.51-4.44-9.92-9.98-9.92H46.7
	c-5.54,0-9.98,4.41-9.98,9.92v78.91C36.72,108.96,41.16,113.37,46.7,113.37z M38.94,24.55c0-4.19,3.55-7.71,7.76-7.71h34.6
	c4.21,0,7.76,3.53,7.76,7.71v78.91c0,4.19-3.55,7.71-7.76,7.71H46.7c-4.21,0-7.76-3.53-7.76-7.71V24.55z"
    />
    <path
      style={{ fillRule: "evenodd", clipRule: "evenodd", fill: "#231F20" }}
      d="M59.12,101.03c0,2.64,2.22,4.85,4.88,4.85c2.66,0,4.88-2.2,4.88-4.85c0-2.64-2.22-4.85-4.88-4.85
	C61.34,96.18,59.12,98.38,59.12,101.03z M61.34,101.25c0-1.54,1.11-2.64,2.66-2.64s2.66,1.1,2.66,2.64s-1.11,2.64-2.66,2.64
	S61.34,102.79,61.34,101.25z"
    />
    <path
      style={{ fillRule: "evenodd", clipRule: "evenodd", fill: "#231F20" }}
      d="M45.37,59.59h13.09c0.67,0,1.11-0.44,1.11-1.1v-13c0-0.66-0.44-1.1-1.11-1.1H45.37c-0.67,0-1.11,0.44-1.11,1.1
	v13C44.26,59.15,44.7,59.59,45.37,59.59z M57.35,57.39H46.48v-10.8h10.87V57.39z"
    />
    <path
      style={{ fill: "#231F20" }}
      d="M52.91,54.08h-1.77c-0.67,0-1.11-0.44-1.11-1.1v-1.76c0-0.66,0.44-1.1,1.11-1.1h1.77c0.67,0,1.11,0.44,1.11,1.1
	v1.76C54.02,53.42,53.35,54.08,52.91,54.08z"
    />
    <path
      style={{ fillRule: "evenodd", clipRule: "evenodd", fill: "#231F20" }}
      d="M45.37,83.62h13.09c0.67,0,1.11-0.44,1.11-1.1v-13c0-0.66-0.44-1.1-1.11-1.1H45.37c-0.67,0-1.11,0.44-1.11,1.1
	v13C44.26,83.18,44.7,83.62,45.37,83.62z M57.35,81.41H46.48v-10.8h10.87V81.41z"
    />
    <path
      style={{ fill: "#231F20" }}
      d="M52.91,78.11h-1.77c-0.67,0-1.11-0.44-1.11-1.1v-1.76c0-0.66,0.44-1.1,1.11-1.1h1.77c0.67,0,1.11,0.44,1.11,1.1
	V77C54.02,77.67,53.35,78.11,52.91,78.11z"
    />
    <path
      style={{ fillRule: "evenodd", clipRule: "evenodd", fill: "#231F20" }}
      d="M69.54,59.59h13.09c0.67,0,1.11-0.44,1.11-1.1v-13c0-0.66-0.44-1.1-1.11-1.1H69.54c-0.67,0-1.11,0.44-1.11,1.1
	v13C68.44,59.15,68.88,59.59,69.54,59.59z M81.52,57.39H70.65v-10.8h10.87V57.39z"
    />
    <path
      style={{ fill: "#231F20" }}
      d="M77.09,54.08h-1.77c-0.67,0-1.11-0.44-1.11-1.1v-1.76c0-0.66,0.44-1.1,1.11-1.1h1.77c0.67,0,1.11,0.44,1.11,1.1
	v1.76C78.19,53.42,77.75,54.08,77.09,54.08z"
    />
    <path
      style={{ fill: "#231F20" }}
      d="M64,72.6c-0.67,0-1.11-0.44-1.11-1.1V65.1H49.14c-0.67,0-1.11-0.44-1.11-1.1c0-0.66,0.44-1.1,1.11-1.1H64
	c0.67,0,1.11,0.44,1.11,1.1v7.49C65.11,72.16,64.67,72.6,64,72.6z"
    />
    <path
      style={{ fill: "#231F20" }}
      d="M64,48.35c-0.67,0-1.11-0.44-1.11-1.1v-1.76c0-0.66,0.44-1.1,1.11-1.1c0.67,0,1.11,0.44,1.11,1.1v1.76
	C65.11,47.91,64.67,48.35,64,48.35z"
    />
    <path
      style={{ fill: "#231F20" }}
      d="M64,59.59c-0.67,0-1.11-0.44-1.11-1.1v-5.51c0-0.66,0.44-1.1,1.11-1.1c0.67,0,1.11,0.44,1.11,1.1v5.51
	C65.11,59.15,64.67,59.59,64,59.59z"
    />
    <path
      style={{ fill: "#231F20" }}
      d="M75.31,78.11h-5.54c-0.67,0-1.11-0.44-1.11-1.1c0-0.66,0.44-1.1,1.11-1.1h4.44v-0.66c0-0.66,0.44-1.1,1.11-1.1
	c0.67,0,1.11,0.44,1.11,1.1V77C76.42,77.67,75.75,78.11,75.31,78.11z"
    />
    <path
      style={{ fill: "#231F20" }}
      d="M82.63,83.62h-7.54c-0.67,0-1.11-0.44-1.11-1.1c0-0.66,0.44-1.1,1.11-1.1h6.43v-8.16c0-0.66,0.44-1.1,1.11-1.1
	c0.67,0,1.11,0.44,1.11,1.1v9.26C83.74,83.18,83.3,83.62,82.63,83.62z"
    />
    <path
      style={{ fill: "#231F20" }}
      d="M69.54,24.33H58.23c-0.67,0-1.11-0.44-1.11-1.1c0-0.66,0.44-1.1,1.11-1.1h11.31c0.67,0,1.11,0.44,1.11,1.1
	C70.65,23.89,70.21,24.33,69.54,24.33z"
    />
    <path
      style={{ fill: "#231F20" }}
      d="M69.54,83.62H64c-0.67,0-1.11-0.44-1.11-1.1V77c0-0.66,0.44-1.1,1.11-1.1c0.67,0,1.11,0.44,1.11,1.1v4.41h4.44
	c0.67,0,1.11,0.44,1.11,1.1C70.65,83.18,70.21,83.62,69.54,83.62z"
    />
    <path
      style={{ fillRule: "evenodd", clipRule: "evenodd", fill: "#231F20" }}
      d="M69.77,70.61h5.54c0.44,0,1.11-0.44,1.11-1.1V64c0-0.66-0.44-1.1-1.11-1.1h-5.54c-0.67,0-1.11,0.44-1.11,1.1
	v5.51C68.66,70.17,69.1,70.61,69.77,70.61z M73.98,68.41h-3.33V65.1h3.33V68.41z"
    />
    <path
      style={{ fill: "#231F20" }}
      d="M82.63,68.85c-0.67,0-1.11-0.44-1.11-1.1V65.1h-0.67c-0.67,0-1.11-0.44-1.11-1.1c0-0.66,0.44-1.1,1.11-1.1h1.77
	c0.67,0,1.11,0.44,1.11,1.1v3.75C83.74,68.41,83.3,68.85,82.63,68.85z"
    />
  </svg>
);

export default Phone;
